
// const API_BASE = "https://assocham.org/api";


// const SLUG_OVERRIDES = {
//   // "andhra-pradesh": "andhra-pradesh-state-development-council",
//   // "jammu-kashmir": "jk-state-development-council",
// };

// export async function getRegionBySlug(slug) {
//   if (!slug) return null;
//   const dbSlug = SLUG_OVERRIDES[slug] || slug;

//   try {
//     const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
//     const json = await res.json();

//     if (!json.success) return null;
//     return json.data;
//   } catch (err) {
//     console.error("getRegionBySlug error:", err);
//     return null;
//   }
// }

// export async function getCouncilLeadership(slug) {
//   try {
//     const res = await fetch(`/api/getCouncilLeadership-state.php?slug=${encodeURIComponent(slug)}`);
//     const json = await res.json();
//     if (json.success) {
//       return json.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Failed to fetch council leadership:', error);
//     return [];
//   }
// }




// new new code 






const API_BASE = "https://assocham.org/api";

const SLUG_OVERRIDES = {
  // "andhra-pradesh": "andhra-pradesh-state-development-council",
  // "jammu-kashmir": "jk-state-development-council",
};

export async function getRegionBySlug(slug) {
  if (!slug) return null;
  const dbSlug = SLUG_OVERRIDES[slug] || slug;

  try {
    const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();

    if (!json.success) return null;
    return json.data;
  } catch (err) {
    console.error("getRegionBySlug error:", err);
    return null;
  }
}

export async function getCouncilLeadership(slug) {
  try {
    // ✅ Use absolute URL with API_BASE
    const res = await fetch(`${API_BASE}/getCouncilLeadership-state.php?slug=${encodeURIComponent(slug)}`);
    const json = await res.json();
    if (json.success) {
      return json.data;
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch council leadership:', error);
    return [];
  }
}